import { createAction, props } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";

const actionName = "[ ObterArquivoPoliticaPrivacidade ] Obter arquivo Política de Privacidade";

export const obterArquivoPoliticaPrivacidade = createAction(
  actionName
);

export const obterArquivoPoliticaPrivacidadeSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<string> }>()
);

export const obterArquivoPoliticaPrivacidadeFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<string> }>()
);

export const obterArquivoPoliticaPrivacidadeFinish = createAction(
  `${actionName} - Concluir`
);